/* Superluxe order tracking page (sections/sl-track-order.liquid). No dependencies. */
(function () {
  var CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  var FINAL = { ship: 'Shipped', pickup: 'Ready for pick-up' };
  function fmt(iso) {
    if (!iso) return '';
    var p = iso.split('-'); if (p.length !== 3) return '';
    var d = new Date(+p[0], +p[1] - 1, +p[2]);
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  }
  function fmtEst(iso) {
    var p = (iso || '').split('-'); if (p.length !== 3) return '';
    var d = new Date(+p[0], +p[1] - 1, +p[2]); if (isNaN(d)) return '';
    return d.toLocaleDateString('en-US', { weekday: 'short' }) + ', ' + d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }
  var PHRASE = { quote: 'being quoted', proof: 'being proofed', approved: 'approved', production: 'in production' };
  var burst = 0;
  function confetti() {
    try { if (burst || matchMedia('(prefers-reduced-motion: reduce)').matches) return; } catch (e) { return; }
    var c = document.createElement('canvas'), x = c.getContext('2d'), W = innerWidth, H = innerHeight, r = devicePixelRatio || 1, P = [], C = ['#FFB74A', '#FFB74A', '#F5F4F1', '#121212', '#fff'], t0;
    if (!x) return; burst = 1;
    c.width = W * r; c.height = H * r; c.setAttribute('aria-hidden', 'true');
    c.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:2147483647';
    document.body.appendChild(c); x.scale(r, r);
    for (var i = 0; i < 110; i++) P.push({ x: Math.random() * W, y: -Math.random() * H * .6 - 10, w: 5 + Math.random() * 5, h: 8 + Math.random() * 6, v: 3 + Math.random() * 4, d: Math.random() * 6, s: .05 + Math.random() * .1, a: Math.random() * 6, c: C[i % 5] });
    function f(t) {
      t0 = t0 || t; var k = (t - t0) / 2000; x.clearRect(0, 0, W, H);
      if (k >= 1) { c.remove(); burst = 0; return; }
      x.globalAlpha = k > .75 ? (1 - k) * 4 : 1;
      P.forEach(function (p) {
        p.y += p.v; p.a += p.s; p.x += Math.sin(p.a + p.d) * .8;
        x.save(); x.translate(p.x, p.y); x.rotate(p.a); x.scale(1, Math.cos(p.a * 1.7));
        x.fillStyle = p.c; x.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        if (p.c === '#121212') { x.strokeStyle = 'rgba(245,244,241,.85)'; x.lineWidth = 1; x.strokeRect(-p.w / 2, -p.h / 2, p.w, p.h); }
        x.restore();
      });
      requestAnimationFrame(f);
    }
    requestAnimationFrame(f);
  }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function safeUrl(u) { try { var x = new URL(u); return (x.protocol === 'https:' || x.protocol === 'http:') ? x.href : null; } catch (e) { return null; } }
  // Same-page proof viewer: dark overlay, fit-to-screen image, tap/click to zoom + pan, pinch on phones,
  // closes on X / Esc / backdrop, scroll locked, focus trapped. Built once, appended to <body>.
  var LB = null;
  function lightbox(src, pdf, title, alt, opener) {
    if (!LB) {
      var root = el('div', 'sl-plb'); root.hidden = true;
      root.setAttribute('role', 'dialog'); root.setAttribute('aria-modal', 'true');
      var bar = el('div', 'sl-plb__bar'), ttl = el('p', 'sl-plb__title');
      var x = el('button', 'sl-plb__x'); x.type = 'button'; x.setAttribute('aria-label', 'Close');
      x.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 5l14 14M19 5L5 19" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>';
      bar.appendChild(ttl); bar.appendChild(x);
      var st = el('div', 'sl-plb__stage'), img = el('img', 'sl-plb__img');
      img.tabIndex = 0; img.setAttribute('role', 'button'); img.setAttribute('aria-label', 'Zoom in or out'); img.referrerPolicy = 'no-referrer'; img.decoding = 'async';
      st.appendChild(img);
      var ft = el('div', 'sl-plb__foot'), hint = el('p', 'sl-plb__hint', '');
      var dl = el('a', 'sl-plb__dl', 'Download PDF'); dl.setAttribute('download', ''); dl.rel = 'noopener noreferrer';
      ft.appendChild(hint); ft.appendChild(dl);
      root.appendChild(bar); root.appendChild(st); root.appendChild(ft);
      document.body.appendChild(root);
      var state = { y: 0, opener: null };
      var setHint = function () { hint.textContent = root.classList.contains('is-z') ? 'Drag or scroll to look around \u00b7 tap to fit' : 'Tap the proof to zoom \u00b7 pinch on phones'; };
      var zoom = function (ev) {
        var r = img.getBoundingClientRect(), fx = 0.5, fy = 0.5;
        if (ev && ev.clientX != null && r.width) { fx = (ev.clientX - r.left) / r.width; fy = (ev.clientY - r.top) / r.height; }
        root.classList.toggle('is-z'); setHint();
        if (root.classList.contains('is-z')) { st.scrollLeft = fx * st.scrollWidth - st.clientWidth / 2; st.scrollTop = fy * st.scrollHeight - st.clientHeight / 2; }
        else { st.scrollLeft = 0; st.scrollTop = 0; }
      };
      var close = function () {
        if (root.hidden) return;
        root.hidden = true; root.classList.remove('is-z');
        var b = document.body; document.documentElement.classList.remove('sl-plb-lock');
        b.style.position = ''; b.style.top = ''; b.style.left = ''; b.style.right = ''; b.style.width = '';
        window.scrollTo(0, state.y);
        if (state.opener && document.contains(state.opener)) try { state.opener.focus({ preventScroll: true }); } catch (e) { state.opener.focus(); }
      };
      img.addEventListener('click', function (ev) { ev.stopPropagation(); zoom(ev); });
      img.addEventListener('keydown', function (ev) { if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); zoom(); } });
      x.addEventListener('click', close);
      root.addEventListener('click', function (ev) { if (!ev.target.closest('.sl-plb__img, a, button')) close(); });
      document.addEventListener('keydown', function (ev) {
        if (root.hidden) return;
        if (ev.key === 'Escape') { ev.preventDefault(); close(); return; }
        if (ev.key === 'Tab') {
          var f = [x, img].concat(dl.hidden ? [] : [dl]), i = f.indexOf(document.activeElement);
          ev.preventDefault();
          f[(i < 0 ? 0 : i + (ev.shiftKey ? f.length - 1 : 1)) % f.length].focus();
        }
      });
      LB = { root: root, ttl: ttl, img: img, dl: dl, x: x, st: st, state: state, setHint: setHint };
    }
    var L = LB, b = document.body;
    L.root.setAttribute('aria-label', title + ', full size');
    L.ttl.textContent = title;
    if (L.img.getAttribute('src') !== src) L.img.src = src;
    L.img.alt = alt;
    if (pdf) { L.dl.href = pdf; L.dl.hidden = false; } else { L.dl.removeAttribute('href'); L.dl.hidden = true; }
    L.root.classList.remove('is-z'); L.setHint();
    L.state.opener = opener || document.activeElement; L.state.y = window.scrollY || window.pageYOffset || 0;
    document.documentElement.classList.add('sl-plb-lock');
    b.style.position = 'fixed'; b.style.top = (-L.state.y) + 'px'; b.style.left = '0'; b.style.right = '0'; b.style.width = '100%';
    L.root.hidden = false; L.st.scrollTop = 0; L.st.scrollLeft = 0;
    L.x.focus();
  }
  // Card-size preview first (srcset adds the 1600px one for big/retina screens); the lightbox always uses image_url (full).
  var SIZES = '(min-width: 990px) 460px, 92vw';
  function setSrc(img, pv) {
    var card = pv.image_card_url && safeUrl(pv.image_card_url), full = pv.image_url && safeUrl(pv.image_url);
    if (card && full && card !== full) { img.sizes = SIZES; img.srcset = card + ' 900w, ' + full + ' 1600w'; }
    img.src = card || full;
  }
  // Resolve when the proof preview is decoded (or failed), or after `cap` ms, whichever is first.
  function preload(pv, cap) {
    return new Promise(function (done) {
      if (!pv || !(pv.image_card_url || pv.image_url)) { done(); return; }
      var finished = false, fin = function () { if (!finished) { finished = true; done(); } };
      var t = setTimeout(fin, cap);
      try {
        var img = new Image(); img.decoding = 'async'; img.referrerPolicy = 'no-referrer'; setSrc(img, pv);
        var after = function () { clearTimeout(t); fin(); };
        if (img.decode) img.decode().then(after, after); else { img.onload = after; img.onerror = after; }
      } catch (e) { clearTimeout(t); fin(); }
    });
  }
  function init(root) {
    var form = root.querySelector('form'), msg = root.querySelector('.sl-to__msg'), btn = root.querySelector('.sl-to__submit');
    var res = root.querySelector('.sl-to__result'), status = res.querySelector('[data-status]'), num = res.querySelector('[data-num]');
    var steps = res.querySelectorAll('.sl-to__step'), facts = res.querySelector('[data-facts]'), actions = res.querySelector('[data-actions]'), note = res.querySelector('[data-note]');
    var endpoint = root.getAttribute('data-endpoint');
    var contactInput = form.elements.contact;
    // ?order=101271 (link in the shipped text) prefills the order box; the customer still types their email or mobile.
    try { var q0 = new URLSearchParams(location.search).get('order'); if (q0 && !form.elements.order.value) form.elements.order.value = String(q0).trim().slice(0, 40); } catch (e) {}
    contactInput.addEventListener('input', function () {
      var v = contactInput.value.trim();
      contactInput.setAttribute('inputmode', v && !/[a-z@]/i.test(v) ? 'tel' : 'email');
    });
    function showMsg(t) { msg.textContent = t; msg.hidden = !t; }
    function render(o) {
      res.classList.remove('sl-to__empty');
      num.textContent = 'Order ' + (/^\d/.test(o.order_number || '') ? '#' : '') + o.order_number;
      var name = o.first_name && /^[A-Za-z\u00C0-\u024F'\-]{2,30}$/.test(o.first_name) ? o.first_name : '';
      var phrase = PHRASE[o.step] || 'being quoted';
      var pick = o.fulfillment === 'pickup', verb = 'is';
      if (o.step === 'done') { phrase = pick ? 'ready for pick-up' : 'shipped'; if (!pick) verb = 'has'; }
      if (o.step === 'delivered') { phrase = pick ? 'picked up' : 'delivered'; verb = 'has been'; }
      status.textContent = (name ? 'Hi ' + name + '! ' : '') + 'Your order ' + verb + ' ';
      status.appendChild(el('span', 'sl-to__phrase', phrase)); status.appendChild(document.createTextNode('.'));
      var lastLabel = FINAL[o.fulfillment] || 'Ready / Shipped';
      steps.forEach(function (li, i) {
        var dot = li.querySelector('.sl-to__dot'), sr = li.querySelector('[data-sr]');
        li.classList.remove('is-done', 'is-cur'); li.removeAttribute('aria-current');
        if (i === 4) li.querySelector('[data-label]').textContent = lastLabel;
        if (i === 5) li.querySelector('[data-label]').textContent = o.fulfillment === 'pickup' ? 'Picked up' : 'Delivered';
        var done = i < o.step_index || (i === o.step_index && i >= 4);
        if (done) { li.classList.add('is-done'); dot.innerHTML = CHECK; sr.textContent = ' (done)'; }
        else if (i === o.step_index) { li.classList.add('is-cur'); li.setAttribute('aria-current', 'step'); dot.textContent = String(i + 1); sr.textContent = ' (current step)'; }
        else { dot.textContent = String(i + 1); sr.textContent = ' (to do)'; }
      });
      facts.innerHTML = '';
      var oldEst = res.querySelector('.sl-to__est'); if (oldEst) oldEst.remove();
      var est = o.step === 'production' ? fmtEst(o.est_ship_date) : '';
      if (est) {
        var eb = el('div', 'sl-to__est'); eb.style.cssText = 'margin:0 0 22px;padding:14px 16px;border-radius:var(--sl-r-sm,12px);background:rgba(255,183,74,.12);border:1px solid rgba(255,183,74,.35)';
        var line = el('p', null, 'Est. ship / pick-up: ' + est); line.style.cssText = 'margin:0;font-size:17px;font-weight:700;color:#fff';
        var sm = el('small', null, "Estimate. We'll text or email if anything changes."); sm.style.cssText = 'display:block;margin-top:4px;font-size:13px;color:rgba(255,255,255,.7)';
        eb.appendChild(line);
        if (o.est_ship_note) { var rn = el('p', null, String(o.est_ship_note).slice(0, 160)); rn.style.cssText = 'margin:6px 0 0;font-size:15px;color:#fff'; eb.appendChild(rn); }
        eb.appendChild(sm); facts.parentNode.insertBefore(eb, facts);
      }
      function fact(k, v, mod) { if (!v) return; var w = el('div', 'sl-to__fact' + (mod ? ' sl-to__fact--' + mod : '')); w.appendChild(el('dt', null, k)); w.appendChild(el('dd', null, v)); facts.appendChild(w); }
      fact('In-hands date', fmt(o.in_hands_date));
      fact('Last update', fmt(o.last_update));
      if (o.carrier) fact('Carrier', o.carrier);
      if (o.tracking_number) fact('Tracking #', o.tracking_number, 'track');
      facts.hidden = !facts.children.length;
      var oldPf = res.querySelector('.sl-to__proof'); if (oldPf) oldPf.remove();
      var pv = o.proof || null, pImg = pv && pv.image_url && safeUrl(pv.image_url), pPdf = pv && pv.pdf_url && safeUrl(pv.pdf_url);
      if (pImg || pPdf) {
        // The customer's latest proof (the approved one once approved): token links from the proofs app, image + PDF only.
        var pdl = (pv.download_url && safeUrl(pv.download_url)) || pPdf;
        var box = el('section', 'sl-to__proof'); box.setAttribute('aria-label', 'Your proof');
        box.appendChild(el('p', 'sl-to__pcap', String(pv.label || (pv.approved ? 'Your approved proof' : 'Your proof')).slice(0, 90)));
        var title = String(pv.label || (pv.approved ? 'Your approved proof' : 'Your proof')).slice(0, 90);
        var alt = 'Proof' + (pv.version ? ' version ' + pv.version : '') + ' for order ' + (o.order_number || '');
        var openLb = function (ev) { lightbox(pImg, pdl, title, alt + ', full size', ev && ev.currentTarget); };
        var pa = el('div', 'sl-to__pact');
        // No preview image (or it fails to load): an intentional file tile + the PDF download, never a lone button.
        var tile = function () {
          var t = el('div', 'sl-to__pnone');
          t.innerHTML = '<svg width="34" height="34" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M7 3h7l5 5v13H7z M14 3v5h5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M9.5 13h7M9.5 16h7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
          t.appendChild(el('p', 'sl-to__pnone-t', 'Your proof is saved as a PDF'));
          t.appendChild(el('p', 'sl-to__pnone-s', 'The preview can\u2019t be shown here, but the full proof is ready to download.'));
          if (pdl) { var d2 = el('a', 'sl-btn sl-btn--accent', 'Download PDF'); d2.href = pdl; d2.setAttribute('download', ''); d2.rel = 'noopener noreferrer'; t.appendChild(d2); }
          return t;
        };
        if (pImg) {
          var fr = el('button', 'sl-to__pframe'); fr.type = 'button';
          fr.setAttribute('aria-label', 'View your proof full size');
          var im = el('img'); setSrc(im, pv); im.alt = alt;
          im.decoding = 'async'; im.referrerPolicy = 'no-referrer'; im.setAttribute('fetchpriority', 'high');
          var iw = +pv.image_w || 1400, ih = +pv.image_h || 1082;
          im.width = iw; im.height = ih; im.style.aspectRatio = iw + ' / ' + ih;  // reserved box: no layout jump
          if (im.complete && im.naturalWidth) im.classList.add('is-in');
          else im.addEventListener('load', function () { im.classList.add('is-in'); });
          fr.appendChild(im); fr.appendChild(el('span', 'sl-to__pzoom', 'View full size')); box.appendChild(fr);
          fr.addEventListener('click', openLb);
          var v = el('button', 'sl-btn sl-btn--accent', 'View full proof'); v.type = 'button'; v.addEventListener('click', openLb); pa.appendChild(v);
          if (pdl) { var d = el('a', 'sl-btn sl-btn--ghost-light', 'Download PDF'); d.href = pdl; d.setAttribute('download', ''); d.rel = 'noopener noreferrer'; pa.appendChild(d); }
          im.onerror = function () { if (fr.parentNode) { box.replaceChild(tile(), fr); pa.remove(); } };
        } else {
          box.appendChild(tile()); pa = null;
        }
        if (pa) box.appendChild(pa);
        actions.parentNode.insertBefore(box, actions);
      }
      actions.innerHTML = '';
      var proof = o.proof_url && safeUrl(o.proof_url), trk = o.tracking_url && safeUrl(o.tracking_url);
      if (proof) { var a = el('a', 'sl-btn sl-btn--accent', 'Review and approve your proof'); a.href = proof; actions.appendChild(a); }
      if (trk) { var t = el('a', 'sl-btn sl-btn--accent', 'Track your package'); t.href = trk; t.target = '_blank'; t.rel = 'noopener noreferrer'; actions.appendChild(t); }
      actions.hidden = !actions.children.length;
      var n = '';
      if (o.changes_requested) n = "We're working on your changes. We'll text you the revised proof.";
      else if (o.step === 'quote') n = "We've got your order. Your proof is next.";
      else if (o.step === 'approved') n = 'Your proof is approved. ' + (o.method === 'embroidery' ? 'Stitching starts soon.' : o.method === 'print' ? 'Printing starts soon.' : 'Your order is next in line.');
      else if (o.step === 'production') n = "Your order is in production.";
      else if (o.step === 'done' && o.fulfillment === 'pickup') n = 'Your order is ready to pick up.';
      else if (o.step === 'delivered') n = o.fulfillment === 'pickup' ? 'Thanks for picking up your order.' : 'Your order has been delivered. Thanks!';
      note.textContent = n; note.hidden = !n;
      if (o.step === 'done' || o.step === 'delivered') confetti();
      status.focus({ preventScroll: true });
      if (window.matchMedia('(max-width: 900px)').matches) res.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var order = form.elements.order.value.trim(), contact = contactInput.value.trim();
      [form.elements.order, contactInput].forEach(function (i) { i.removeAttribute('aria-invalid'); });
      if (!order || !contact) {
        showMsg('Enter your order number (or order name) and the email or mobile number on the order.');
        (!order ? form.elements.order : contactInput).setAttribute('aria-invalid', 'true');
        (!order ? form.elements.order : contactInput).focus();
        return;
      }
      showMsg(''); btn.disabled = true; var label = btn.textContent, started = Date.now();
      var r0 = btn.getBoundingClientRect(); btn.style.width = r0.width + 'px'; btn.style.height = r0.height + 'px';  // no jump
      btn.setAttribute('aria-busy', 'true'); btn.classList.add('is-loading');
      btn.innerHTML = 'Finding your order<span class="sl-to__dots" aria-hidden="true"><i></i><i></i><i></i></span>';
      var url = endpoint + (endpoint.indexOf('?') > -1 ? '&' : '?') + 'order=' + encodeURIComponent(order) + '&contact=' + encodeURIComponent(contact);
      fetch(url, { method: 'GET', mode: 'cors', credentials: 'omit', cache: 'no-store', referrerPolicy: 'no-referrer' })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { code: r.status, j: j }; }); })
        .then(function (x) {
          if (x.code === 200 && x.j && x.j.ok && x.j.order) {
            var o = x.j.order;
            // Reveal the whole result together: wait for the proof preview, at most ~2.5 s after the click (then it fades in in place).
            return preload(o.proof, Math.max(250, 2500 - (Date.now() - started))).then(function () { render(o); });
          }
          showMsg((x.j && x.j.message) || "We couldn't find an order matching those details.");
        })
        .catch(function () { showMsg("We couldn't reach order tracking just now. Please try again in a minute, or call 480-248-3379."); })
        .then(function () { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.classList.remove('is-loading'); btn.textContent = label; btn.style.width = ''; btn.style.height = ''; });
    });
  }
  function all() { document.querySelectorAll('[data-sl-track]').forEach(function (r) { if (!r.__slTo) { r.__slTo = 1; init(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
